import React from 'react'
import { Grid, Header } from 'semantic-ui-react'
import InputField from '../../../../commonComponents/formComponents/inputField'
import DropDown from '../../../../commonComponents/formComponents/dropDown'
import { useSelector } from 'react-redux'
import DeleteIcon from '../../../../commonComponents/deleteIcon'
import CopyRepElement from '../../itemsTab/copyRepElement'
import PopUpIcon from '../../../../commonComponents/formComponents/PopUpIcon'
import { useCurrentShipmentType } from '../../../../hooks/useCurrentShipmentType'

const AdditionalDocsDetails = ({
  item: { code, description, id },
  deleteData,
  updateData,
  saveData,
  isItemTab,
  copyData,
  isFormDisabled = false,
  isImportShipment
}) => {
  const additionalInfoCode = useSelector((state) => state.DropDownValues.additionalInfoCode)
  const additionalInfoDetails = useSelector((state) => state.DropDownValues.additionalInfoDetails)
  const descriptionList = useSelector((state) => state.DropDownValues.additionalInfoCodeDesc)
  const {codeUsage,detailesEntered}=React.useMemo(()=>{
      return {codeUsage :additionalInfoCode?.find(c=>c.value==code)?.text,detailesEntered:additionalInfoDetails?.find(c=>c.value==code)?.text}
    },[additionalInfoCode,code,additionalInfoDetails])

    const {isDisabled} = useCurrentShipmentType()
 
  return (
    <Grid.Row>
      {isItemTab && (
        <Grid.Column width={1} style={{textAlign:'center'}}>
         <CopyRepElement 
            title={`ADDITIONAL INFORMATION`}
            request={{ code, description}}
            callback={copyData}
            isFormDisabled={isDisabled}
         />
      </Grid.Column>
      )}
      <Grid.Column width='7' className='divFormFeild border-bottom b-rw-0'>
        <DropDown
          id={`code-${id}`}
          label='Code'
          disabled={isFormDisabled}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          isLabel={true}
          data={additionalInfoCode}
          clearable
          value={code}
          onChange={(value) => {
            let description=' '
            if(value?.trim())
                description=descriptionList?.find(c=>c.value==value)?.text || ''
            saveData({ id, code: value || ' ',description })
            updateData(id, { code: value?.trim(),description:description?.trim() })
          }}
        />
      </Grid.Column>
      <Grid.Column width={isItemTab ? 6 : 7} className='divFormFeild border-bottom b-trr-5 b-brr-5'>
        <InputField
          isLabel={false}
          id={`description-${id}`}
          type='text'
          label='Description'
          value={description}
          className='field-bg'
          onChange={(value) => updateData(id, { description: value })}
          onBlur={(value) => saveData({ id, description: description || ' ' })}
          disabled={isFormDisabled}
        />
      </Grid.Column>
       <Grid.Column  className='actionIcon'>
         {code && <PopUpIcon popupStyle={{maxWidth:'600px',minWidth:'100px'}} icon="info circle"  popupText={
          <>
          <ul><li style={{marginBottom:'5px'}}><Header size='medium'>Description and Usage of Code</Header></li><li><Header size='small'>{codeUsage}</Header></li></ul>
          <ul style={{marginTop:'5px'}}><li style={{marginBottom:'5px'}}><Header size='medium'>Details to be Entered</Header></li><li><Header size='small'>{detailesEntered}</Header></li></ul>
          </>
        
          } />
        }
            
      </Grid.Column>

      <Grid.Column className='actionIcon'>
        <DeleteIcon id={`additionalInfoDelete-${id}`} onClick={() =>deleteData(id)} disabled={isFormDisabled} />
      </Grid.Column>
    </Grid.Row>
  )
}
export default React.memo(AdditionalDocsDetails)
